import {Component, OnInit} from '@angular/core';
import {TrackChangesRestService} from '../shared/services/track-changes/track-changes-rest.service';
import {
  ActionType, ObjectType, ObjectTypeI,
  SearchModel,
  TrackChange,
  TrackChangesResponse
} from '../shared/types/track-changes/track-changes';
import {BasicPersonData} from '../shared/types/person/basic-person-data';
import * as moment from 'moment';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'wsd-track-changes',
  templateUrl: './track-changes.component.html',
  styleUrls: ['./track-changes.component.css']
})
export class TrackChangesComponent implements OnInit {

  objectId: number;
  dates: Array<Date>;
  persons: BasicPersonData[] = [];
  selectedAuthor: BasicPersonData;
  objectTypeOptions: Array<ObjectTypeI>;
  selectedObjectType: Array<ObjectTypeI> = [];
  createCheckbox: boolean = false;
  updateCheckbox: boolean = false;
  deleteCheckbox: boolean = false;

  searchModel: SearchModel = new SearchModel();
  pageSize = 10;
  currentPage = 0;

  trackChangesResponse: TrackChangesResponse;

  DEFAULT_DATE_FORMAT = 'DD/MM/YYYY HH:mm:ss';

  constructor(private trackChangesRestService: TrackChangesRestService,
              public translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.objectTypeOptions =  [
      {name: ObjectType.WSD_ORGANIZATION,
        translation: this.translateService.instant('TRACK_CHANGES.OBJECT_TYPE.ORGANIZATION'),
        value: 1
      }, { name: ObjectType.WSD_CONSULTANT,
        translation: this.translateService.instant('TRACK_CHANGES.OBJECT_TYPE.PERSON'),
        value: 0}
    ];
    this.search(true);
  }


  getFormattedDate(date: Date): string {
    return moment(date).format(this.DEFAULT_DATE_FORMAT).toString();
  }

  getTranslationFromObjectTypeOptions(objType: ObjectType): string {
    switch (objType.toString()) {
      case ObjectType[ObjectType.WSD_ORGANIZATION] :
        return this.objectTypeOptions[0].translation;
      case ObjectType[ObjectType.WSD_CONSULTANT] :
        return this.objectTypeOptions[1].translation;
    }
  }

  search(pagingResetFlag: boolean): void {
    this.searchModel.actionTypes = [];
    this.searchModel.objectId = this.objectId;
    this.addActions(this.searchModel.actionTypes);
    if (this.selectedAuthor !== undefined
    ) {
      this.searchModel.author = this.selectedAuthor !== null ? this.selectedAuthor.id : null;
    }
    this.searchModel.addDates(this.dates);
    this.searchModel.addObjectTypes(this.selectedObjectType);
    this.searchModel.size = this.pageSize;
    this.searchModel.page = this.currentPage;
    if (pagingResetFlag) {
      this.searchModel.page = 0;
    }
    this.trackChangesRestService.findTrackChanges(this.searchModel).subscribe((data: TrackChangesResponse) => {
        this.trackChangesResponse = data;
      }
    );
  }

  reset(): void {
    this.trackChangesResponse = null;
    this.searchModel = new SearchModel();
    this.objectId = null;
    this.dates = null;
    this.selectedObjectType = [];
    this.createCheckbox = false;
    this.updateCheckbox = false;
    this.deleteCheckbox = false;
    this.selectedAuthor = null;
    this.search(true);
  }

  addActions(arr: Array<number>): Array<number> {
    if (this.createCheckbox
    ) {
      arr.push(ActionType.CREATE.valueOf());
    }
    if (this.updateCheckbox) {
      arr.push(ActionType.UPDATE.valueOf());
    }
    if (this.deleteCheckbox) {
      arr.push(ActionType.DELETE.valueOf());
    }
    return arr;
  }

  filterPersons(event) {
    this.trackChangesRestService.getConsultants(event.query, {page: 0, size: 10}).subscribe(
      (data: BasicPersonData[]) => this.persons = data
    );
  }

  getChangeColorClass(trackChange: TrackChange): string {
    switch (trackChange.actionType.toString()) {
      case ActionType[ActionType.CREATE]:
        return 'ql-color-green';
      case ActionType[ActionType.UPDATE]:
        return 'ql-color-orange';
      case ActionType[ActionType.DELETE]:
        return 'ql-color-red';
    }
  }

  getActionTypeTranslation(trackChange: TrackChange): string {
    switch (trackChange.actionType.toString()) {
      case ActionType[ActionType.CREATE]:
        return this.translateService.instant('TRACK_CHANGES.ACTION_TYPE.CREATE');
      case ActionType[ActionType.UPDATE]:
        return this.translateService.instant('TRACK_CHANGES.ACTION_TYPE.UPDATE');
      case ActionType[ActionType.DELETE]:
        return this.translateService.instant('TRACK_CHANGES.ACTION_TYPE.DELETE');
    }
  }

  getFullName(trackChange: TrackChange) {
    return trackChange.createdBy.firstName.concat(' ', trackChange.createdBy.lastName);
  }

  onPageChange(event) {
    this.currentPage = event.page;
    this.search(false);
  }
}
